module.exports = __webpack_public_path__ + "ab.no2.cf2339b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ab.no2.jpg
// module id = KKmO
// module chunks = 0